import { Component, Input, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { GroupReconTransactionsViewModel, ReconTransactionsViewModel } from "../../../models/recon-report-view-model";
import { ReportService } from '../../../services/report.service';
import { GenericReportViewModel, TransactionAmountModel, TransactionAmount, merchantDetails } from '../../../models/generic-report-view-model';

@Component({
  selector: 'reconciled-transaction-report-component',
  templateUrl: './reconciled-transaction-report.component.html'
})

export class ReconciledTransactionReportComponent implements OnInit {

  merchantNameLocation: string;
  raiseWarning!: boolean;
  popupWin: any;
  groupedTerminals: GroupReconTransactionsViewModel[] = [];
  transactionReport: ReconTransactionsViewModel[] = [];
  hasValue: boolean = false;
  grandAmount: string;
  @Input() StartDate: string;
  @Input() EndDate: string;
  @Input() formatDate!: (date: string) => string;
  @Input() convertToDecimal: (amount?: number | null) => string;
  @Input() merchantDetails: merchantDetails = { merchantName: "", merchantNumber: "" };

  transactionTypes: TransactionAmountModel[] = [];
  transactionAmount: TransactionAmount[] = [];
  
  constructor(
    private loader: NgxUiLoaderService,
    private _reportService: ReportService,
    private datePipe: DatePipe) {
  }

  async ngOnInit() {
    this.loader.stop();
  }

  private resetState() {
    this.transactionReport = [];
    this.groupedTerminals = [];
    this.transactionAmount = [];
    this.hasValue = false;
    this.raiseWarning = false;
  }
  private handleEmptyState() {
    this.raiseWarning = true;
    this.loader.stop();
  }

  async GetReport(_reconReport: GenericReportViewModel) {
    this.resetState();
    this.transactionReport = await this._reportService.GetReconData(_reconReport);

    if (!this.transactionReport?.length) {
      this.handleEmptyState();
      return;
    } else {

      const groupTerminalMapping = new Map<string, GroupReconTransactionsViewModel>();

      this.transactionReport.forEach(recon => {
        const dateOfTransaction = this.formatDate(recon.datetimeReq);
        recon.datetimeReq = dateOfTransaction;

        if (!groupTerminalMapping.has(recon.terminalId)) {
          groupTerminalMapping.set(recon.terminalId, {
            terminalId: recon.terminalId,
            datetimeReq: this.datePipe.transform(recon.datetimeReq, 'yyyy-MM-dd hh:mm:ss'),
            pan: recon.pan,
            postTranId: recon.postTranId,
            totalsGroup: recon.totalsGroup,
            tranType: recon.tranType,
            amountAvailable: 0,
            items: []
          });
        }

        const group = groupTerminalMapping.get(recon.terminalId)!;
        group.items.push(recon);
        group.amountAvailable += recon.amountAvailable;
        group.amountAvailable = parseFloat(group.amountAvailable.toFixed(2));
      });

      this.groupedTerminals = Array.from(groupTerminalMapping.values());
      var total = this.groupedTerminals.reduce((sum, group) => sum + group.amountAvailable, 0);
      this.grandAmount = total.toFixed(2).toString();
      //this.grandAmount = (Math.floor(total * 100) / 100).toFixed(2);

      if (this.transactionReport.length > 0) {
        this.merchantNameLocation = this.transactionReport[0].merchantNameLocation + " - " + this.transactionReport[0].cardAcceptorIdCode;
        this.hasValue = true;

        this.merchantDetails = {
          merchantName: this.transactionReport[0].merchantNameLocation + " - Recon transaction report",
          merchantNumber: this.transactionReport[0].cardAcceptorIdCode,
        }

        this.transactionAmount.push({
          tranType: "Grand Total",
          amount: parseFloat(this.grandAmount).toFixed(2)
        });
      }
      this.loader.stop();
    }
  }

  getTerminalTotalGroups(terminalId: string): any[] {
    const terminalGroups = this.transactionReport
      .filter(t => t.terminalId === terminalId)
      .reduce((groups, transaction) => {
        if (!groups[transaction.totalsGroup]) {
          groups[transaction.totalsGroup] = {
            totalsGroup: transaction.totalsGroup,
            amount: 0
          };
        }
        groups[transaction.totalsGroup].amount += transaction.amountAvailable;
        return groups;
      }, {} as any);

    return Object.values(terminalGroups).map((group: any) => ({
      ...group,
      amount: parseFloat(group.amount.toFixed(2))
    }));
  }
}
